import { useEffect } from 'react';
import Script from 'next/script';
import { CookiesProvider } from 'react-cookie';

import { NavProvider } from 'providers/nav';
import { CheckFlexGap } from 'services/utils';

import '../styles/globals.scss';

function MyApp({ Component, pageProps }) {
	useEffect(() => {
		const isFlexGapSupported = CheckFlexGap();

		if (!isFlexGapSupported) {
			document.querySelector('body').classList.add('no-flex-gap')
		}
	}, [] );

	return (
		<NavProvider>
			<CookiesProvider>
				<Component {...pageProps} />

				{/* Start - OneTrust Cookies Consent Notice */}
				<Script
					src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
					data-domain-script="90a6d4fd-f4ad-4521-b28f-6bdc74289641"
					strategy="beforeInteractive"
				/>

				<Script id="onetrustContainer" strategy="beforeInteractive">
					{ `function OptanonWrapper() {}` }
				</Script>
				{/* End - OneTrust Cookies Consent Notice */}
			</CookiesProvider>
		</NavProvider>
	);
}

export default MyApp;
